import template from './radniNalogCreate.html';
import moment from 'moment';

class RadniNalogCreateController {
    constructor(DS, AppConfiguration, $state, logger) {
        this.Model = DS.definitions['RadniNalog'];
        this.view = AppConfiguration().getViewByEntityAndType('RadniNalog', 'CreateView');
        this.$state = $state;
        this.logger = logger;
    }

    $onInit() {
        this.item = {
            datum_naloga: moment().format('YYYY-MM-DD')
        };
        this.fields = this.view.fields();
    }

    submit(item) {
        this.Model.create(item)
            .then(response => {
                // uploader.url = '/api/radni_nalozi/dokument'
                this.$state.go('radniNalog.details', { id: response.id });
            })
            .catch(error => {
                this.logger.error('Oupss...', error.data);
            });
    }
}

RadniNalogCreateController.$inject = ['DS', 'AppConfiguration', '$state', 'logger'];

const RadniNalogCreateComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: RadniNalogCreateController,
    controllerAs: 'vm'
};

export { RadniNalogCreateComponent };
export { RadniNalogCreateController };



// WEBPACK FOOTER //
// ./app/components/radniNalog/radniNalogCreate.component.js